import { useEffect, Suspense } from "react";
import { useQueryLoader } from "react-relay";

import { EditSectionSkeletonLoader } from "../EditSectionSkeletonLoader/EditSectionSkeletonLoader";
import {
  BookingRatesControlInner,
  BookingRatesControlInnerQueryString,
} from "./BookingRatesControlInner";
import { BookingRatesControlInnerQuery } from "./__generated__/BookingRatesControlInnerQuery.graphql";

type Props = {
  bookingId: string;
  currentMembershipTypeId: string;
  durationMins: number;
  groupSize: number;
};

export const BookingRatesControl = ({
  bookingId,
  currentMembershipTypeId,
  durationMins,
  groupSize,
}: Props) => {
  const [queryRef, loadQuery] = useQueryLoader<BookingRatesControlInnerQuery>(
    BookingRatesControlInnerQueryString
  );

  useEffect(() => {
    if (bookingId && currentMembershipTypeId && durationMins && groupSize) {
      loadQuery({
        bookingId,
        membershipTypeId: currentMembershipTypeId,
        duration: durationMins,
        groupSize: groupSize,
      });
    }
  }, [loadQuery, bookingId, currentMembershipTypeId, durationMins, groupSize]);

  return (
    <Suspense fallback={<EditSectionSkeletonLoader />}>
      {queryRef ? <BookingRatesControlInner queryRef={queryRef} /> : null}
    </Suspense>
  );
};
